
import { Box, Grid, InputAdornment, TableHead, TableSortLabel } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'

//component

//utils
import { toBuddhistYear } from 'utils/app.utils'

/** STYLE */

//API
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import ProductTypesApi from 'api/setting/default-products/product-type.api'
import ProductsApi from 'api/warehouses/product.api'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import Loading from 'component/Loading'
import FunctionPrint from 'component/Print/print'
import TableRowCommon from 'component/Table/TableRowCommon'
import * as UseStyled from 'features/report/useStyled'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import { ExportProps } from '../report-constants'
import { ExportStockToExcel, StockReportData } from './exportStockToExcel'
import StockList from './stockList'

export default function Stock() {
    const { t } = useTranslation()
    const history = useHistory();
    const momentDate = () => [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]

    const componentRef = useRef<HTMLDivElement>(null)
    const [branches, setBranches] = useState<any[]>([])
    const [product, setProduct] = useState<any[]>([])
    const [productType, setProductType] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true);

    const [page, setPage] = useState<number>(1)
    const [limit, setLimit] = useState<number>(10)
    const [search, setSearch] = useState<string>('')

    const [branchId, setBranchId] = useState<any>(0)
    const [selectProduct, setSelectProduct] = useState<any>(0)
    const [selectProductType, setSelectProductType] = useState<any>(0)

    const [rangeDate, setRangeDate] = useState<string[]>(momentDate)
    const [stockData, setStockData] = useState<any>([])

    const [rowCount, setRowCount] = useState<number>(0);
    const [exportData, setExportData] = useState<any>([])

    const [fetch, setFetch] = useState<boolean>(false);
    const [sortBy, setSortBy] = useState('')
    const [sortType, setSortType] = useState('')

    const filter = [
        branchId === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(branches, { branchId: branchId }), 'branchName') || _.get(_.find(branches, { branchId: branchId }), 'branchNameEn')}`,
        rangeDate[0] ? toBuddhistYear(moment(rangeDate[0]), 'DD/MM/YYYY') : "-",
        rangeDate[1] ? toBuddhistYear(moment(rangeDate[1]), 'DD/MM/YYYY') : "-",
        selectProductType === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(productType, { productTypeId: selectProductType }), 'productTypeName') || _.get(_.find(productType, { productTypeId: selectProductType }), 'productTypeNameEn')}`,
        selectProduct === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(product, { productId: selectProduct }), 'productName') || _.get(_.find(product, { productId: selectProduct }), 'operativeNameEn')}`,
    ]

    const loadStockExport = useCallback(async () => {
        let condition: any = {
            page: 1, pageLimit: 1000,
            dateStart: rangeDate[0],
            dateEnd: rangeDate[1],
            export: 1
        }
        if (branchId && branchId !== 0) {
            condition = { ...condition, branchId: branchId }
        }
        if (branchId && branchId !== 0) {
            condition = { ...condition, branchId: branchId }
        }
        if (rangeDate) {
            if (rangeDate[0] !== null && rangeDate[1] !== null)
                condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
        }
        if (selectProduct) {
            if (selectProduct !== 0) condition.productId = selectProduct
        }
        if (selectProductType) {
            if (selectProductType !== 0) condition.productTypeId = selectProductType
        }
        if (!_.isEmpty(search)) {
            condition.search = search
        }
        if (!_.isEmpty(sortBy)) {
            condition.sortBy = sortBy
        }

        if (!_.isEmpty(sortType)) {
            condition.sortType = sortType
        }


        ReportApi.reportStock(condition)
            .then(({ headers, data }) => {
                setExportData(data)
            }).catch((e) => setLoading(false))
            .finally(() => {
                setLoading(false)
                setFetch(false)
            })

    }, [fetch, sortBy, sortType])


    const fetchStock = useCallback(() => {
        setLoading(true)
        let condition: any = {
            page: page, pageLimit: limit,
            dateStart: rangeDate[0],
            dateEnd: rangeDate[1],
        }
        if (branchId && branchId !== 0) {
            condition = { ...condition, branchId: branchId }
        }
        if (rangeDate) {
            if (rangeDate[0] !== null && rangeDate[1] !== null)
                condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
        }
        if (selectProduct) {
            if (selectProduct !== 0) condition.productId = selectProduct
        }
        if (selectProductType) {
            if (selectProductType !== 0) condition.productTypeId = selectProductType
        }
        if (!_.isEmpty(search)) {
            condition.search = search
        }
        if (!_.isEmpty(sortBy)) {
            condition.sortBy = sortBy
        }

        if (!_.isEmpty(sortType)) {
            condition.sortType = sortType
        }

        ReportApi.reportStock(condition)
            .then(({ headers, data }) => {
                setStockData(data)
                setRowCount(headers['x-total'])
            }).catch((e) => setLoading(false))
            .finally(() => {
                setLoading(false)
                setFetch(false)
            })

    }, [page, limit, fetch, sortBy, sortType])

    const verifyPermission = async () => {
        const condition: FindAllReportInterface = {
            page: 1, pageLimit: 200
        }
        ReportApi.reportList(condition)
            .then(({ data }) => {
                const check = _.find(data, (val: any) => String(val.reportKey) === 'STOCK') ? true : false
                if (!check) {
                    history.push(routeName.report)
                    return false
                }
            })

        /** MASTER DATA */
        ClinicApi.findAllBranches()
            .then(({ data }) => setBranches(data))
            .catch((e) => { return })

        ProductsApi.findAll({ export: 1 }).then(({ data }) => {
            setProduct([...data])
        }).catch((e) => { return })

        ProductTypesApi.findAll({ export: 1 }).then(({ data }) => {
            setProductType([{ productTypeId: 0, productTypeName: t('REPORT.REPORT_GROUP.ALL') }, ...data])
        }).catch((e) => { return })

        return true
    }

    useEffect(() => {
        verifyPermission()
    }, [])

    useEffect(() => {
        fetchStock()
    }, [fetchStock])

    const headCells = [
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.#', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.DOCUMENT_NO', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.SUBJECT', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.LOT_NO', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.PRODUCT_TYPE', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.PRODUCT', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.EXPIRE_DATE', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.QTY', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.UNIT', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.COST_PRICE', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.SALE_PRICE', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.TOTAL_PRICE', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.STOCK.CREATEDBY', align: 'center', class: 'text-nowrap' },
    ]

    const renderData = (data: any, no: number) => {
        return <>
            <TableRowCommon
                key={(no + 1).toString()}
                id={(no + 1).toString()}
                obj={data}
                columns={[
                    { option: 'TEXT', align: 'center', label: no + 1, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: data.documentNo, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', label: data.subject, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: data.lotNo, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', label: data.itemTypeName, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', label: data.itemName, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: moment(data.expireDate).format('DD/MM/YYYY'), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: data.qty, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: data.itemUnitName || '-', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: data.costPrice, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: data.salePrice, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: data.total, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: data.createdBy, class: 'text-nowrap' },
                ]} />
        </>
    }
    useEffect(() => {
        loadStockExport()
    }, [loadStockExport])

    const handleChangeRowsPerPage = (limit: number) => {
        setLimit(limit)
    }
    const handleChangePage = (val: number) => setPage(val)

    const handleExport = () => {
        const report: StockReportData = {
            branchName: filter[0],
            dateStart: filter[1],
            dateEnd: filter[2],
            productType: filter[3],
            product: filter[4],
            rows: exportData,
            t: t
        }
        ExportStockToExcel(report)
    }

    return (
        <Box sx={{ height: '100%' }}>
            <HeaderCard text={t(`REPORT.REPORT_NAME.STOCK`)} />
            <Box padding="16px">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <TextInput
                            onChange={(e) => setSearch(e.target.value)}
                            fullWidth
                            label={t('REPORT.REPORT_NAME.SEARCH_STOCK')}
                            value={search}
                            inputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => {
                                                    setSearch('');
                                                }}
                                                style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid xs={12} sm={6} item md={3} xl={2}>
                        <SelectInput
                            label={t('REPORT.FILTER.BRANCH')}
                            value={branchId}
                            onChange={e => {
                                setBranchId(Number(e.target.value));
                            }}
                            options={[
                                { value: 0, name: t(`REPORT.FILTER.ALL`) },
                                ...branches.map(b => ({
                                    value: b.branchId,
                                    name: b.branchName || b.branchNameEn || ''
                                }))]}
                            width="100%"
                        />
                    </Grid>
                    <Grid xs={12} sm={6} item md={3} xl={2}>
                        <SelectInput
                            label={t('REPORT.TABLE.STOCK.PRODUCT_TYPE')}
                            value={selectProductType ?? 0}
                            onChange={(e) => {
                                setSelectProductType(e.target.value)
                                setSelectProduct(0)
                            }}
                            options={[
                                ...productType.map((b: any) => ({
                                    value: b.productTypeId,
                                    name: b.productTypeName || b.productTypeNameEn,
                                })),
                            ]}
                            width="100%"
                        />
                    </Grid>
                    <Grid xs={12} sm={6} item md={3} xl={2}>
                        <SelectInput
                            label={t('REPORT.TABLE.STOCK.PRODUCT')}
                            value={selectProduct ?? 0}
                            disabled={!(selectProductType && selectProductType !== 0)}
                            onChange={(e) => {
                                setSelectProduct(e.target.value)
                            }}
                            options={[
                                { value: 0, name: t('REPORT.REPORT_GROUP.ALL') },
                                ...product
                                    .filter(item => item.productTypeId === selectProductType)
                                    .map(b => ({
                                        value: b.productId,
                                        name: b.productName || b.operativeNameEn
                                    }))]}
                            width="100%"
                        />
                    </Grid>
                    <Grid xs={12} sm={6} item md={3} xl={2}>
                        <InputSecondNewRangePicker
                            inputHeight={40}
                            value={rangeDate || emptyRangePicker}
                            onchange={(val: any) => {
                                if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                            }}
                            label={t('REPORT.TABLE.STOCK.EXPIRE_DATE')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={9} xl={2}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                            <MainButton
                                title={t('INPUT.SEARCH')}
                                type="primary"
                                variant="contained"
                                onClick={() => {
                                    setFetch(true);
                                    setPage(1);
                                    setLoading(true)
                                }}
                                style={{ width: '120px' }}
                            />
                            <UseStyled.DropdownDocument>
                                <Dropdown.Toggle id="dropdown-basic" className='ml-xl-auto'>
                                    {t('PRINT_DOCUMENT')}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={handleExport}>
                                        {t('Excel')}
                                    </Dropdown.Item>
                                    <FunctionPrint
                                        content={() => componentRef.current}
                                        docTitle={t(`REPORT.REPORT_NAME.OPERATIVE_SUMMARY_MONTH`)}
                                        removeIfram
                                        trigger={() => <Dropdown.Item >
                                            {t('PDF')}
                                        </Dropdown.Item>}
                                        style={`@page { size: landscape;  margin: 0.5cm; } @media print { body { -webkit-print-color-adjust: exact; }`}
                                    />
                                </Dropdown.Menu>
                            </UseStyled.DropdownDocument>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3, px: { xs: 1 }, pb: 4 }}>
                    <StockList
                        page={page}
                        pageLimit={limit}
                        rowCount={rowCount}
                        data={stockData}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        handleChangePage={handleChangePage}
                        onRequestSort={(by, type) => {
                            setSortBy(by)
                            setSortType(type)
                        }}
                        sortBy={sortBy}
                        sortType={sortType}
                    ></StockList>
                </Box>
            </Box>

            <Loading show={loading} type="fullLoading" />
            <Box id="print-table-container" ref={componentRef}>
                <ExportData
                    filter={filter}
                    componant={
                        <>
                            <UseStyled.Styles className="pt-3">
                                <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%' }}>
                                    <thead>
                                        <tr>
                                            {_.map(headCells, (val: any, index: number) => {
                                                return <td style={{ textAlign: val.align, fontSize: 10, fontWeight: 500 }}> {t(val.labelKey)}</td>
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_.map(exportData, (d: any, index: number) => {
                                            return (
                                                renderData(d, index)
                                            )
                                        })}
                                        {exportData.length === 0 && <td colSpan={headCells.length}>{t('NOT_FOUND')}</td>}
                                    </tbody>
                                </table>
                            </UseStyled.Styles>
                        </>
                    }
                />
            </Box>
        </Box>
    );
}

export function ExportData(props: ExportProps) {
    const { t } = useTranslation()

    const FILTER_TITLES = [
        { key: 'BRANCH', label: 'REPORT.FILTER.BRANCH' },
        { key: 'DATE_START', label: 'REPORT.FILTER.DATE_START' },
        { key: 'DATE_END', label: 'REPORT.FILTER.DATE_END' },
        { key: 'PRODUCT_TYPE', label: 'REPORT.FILTER.PRODUCT_TYPE' },
        { key: 'PRODUCT', label: 'REPORT.FILTER.PRODUCT' },
    ];

    const renderValue = (value: any, index: any) => {
        if (index === 1 || index === 2) {
            return value === '-' ? '-' : toBuddhistYear(moment(value), 'DD/MM/YYYY');
        }
        return value;
    };

    return (
        <>
            <TableHead style={{ fontWeight: 800 }} >{t('REPORT.REPORT_NAME.STOCK')}</TableHead>
            <table>
                <tr>
                    {FILTER_TITLES.map((filter, index) => (
                        <TableSortLabel key={index} >
                            <td style={{ fontSize: 10, fontWeight: 800 }}>{t(filter.label)} : </td>
                            <td style={{ fontSize: 10, fontWeight: 500 }}>{renderValue(props.filter[index], index)}</td>
                        </TableSortLabel>
                    ))}
                </tr>
            </table>
            {props.componant}
        </>)
}